"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_EVENTS = void 0;
var NOTIFICATION_EVENTS;
(function (NOTIFICATION_EVENTS) {
    NOTIFICATION_EVENTS["PAYMENT_FORM_ADDED"] = "paymentFormAdded";
    NOTIFICATION_EVENTS["COMPONENT_DRAGGED_INTO_FROM"] = "componentDraggedIntoForm";
    NOTIFICATION_EVENTS["SUCCESS_MESSAGE_DELETED"] = "messageRole";
    NOTIFICATION_EVENTS["DOWNLOAD_MESSAGE_DELETED"] = "downloadMessageRole";
    NOTIFICATION_EVENTS["EMAIL_FIELD_DELETED"] = "email";
    NOTIFICATION_EVENTS["SUBMISSION_BUTTON_DELETED"] = "buttonRole";
    NOTIFICATION_EVENTS["PREVIOUS_BUTTON_DELETED"] = "previousButton";
    NOTIFICATION_EVENTS["NEXT_BUTTON_DELETED"] = "nextButton";
    NOTIFICATION_EVENTS["RULES_AFFECTED_FIELD_DELETED"] = "rulesAffectedFieldDeleted";
    NOTIFICATION_EVENTS["RULES_AFFECTED_OPTION_DELETED"] = "rulesAffectedOptionDeleted";
    NOTIFICATION_EVENTS["AUTOMATION_AFFECTED_OPTION_CHANGED"] = "automationsAffectedOptionChanged";
    NOTIFICATION_EVENTS["AUTOMATION_AFFECTED_FIELD_DELETED"] = "automationsAffectedFieldDeleted";
    NOTIFICATION_EVENTS["AUTOMATION_AFFECTED_FORM_DELETED"] = "automationsAffectedFormDeleted";
})(NOTIFICATION_EVENTS = exports.NOTIFICATION_EVENTS || (exports.NOTIFICATION_EVENTS = {}));
//# sourceMappingURL=events.js.map